import { render } from "./TheRecommendItem.vue?vue&type=template&id=4c240cba&scoped=true&ts=true"
import script from "./TheRecommendItem.vue?vue&type=script&lang=ts"
export * from "./TheRecommendItem.vue?vue&type=script&lang=ts"

import "./TheRecommendItem.vue?vue&type=style&index=0&id=4c240cba&scoped=true&lang=css"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c240cba"]])

export default __exports__